export const UserLanguages = [
  {id: 'en', name: 'English'},
  {id: 'de', name: 'Deutsch'},
];

export function toUserObject(user) {
  return {
    id: user.id,
    username: user.username || '',
    email: user.email || '',
    language: user.language || 'en',
    role: user.role || 'ROLE_SITE_EMPLOYEE',
    token: user.token,
    sites: user.sites || [],
    authorities: user.authorities || [],
    availableRoles: user.availableRoles || [],
    enabled: user.enabled,
  };
}

export function userIsSupportStaff(user) {
  return user ?
    (user.role === 'ROLE_DIAT' || user.role === 'ROLE_INSTALLATION_ADMIN' || user.role === 'ROLE_SPHINX_DEV') :
    false;
}
